import { SWITCH_USER_ROLE_MODAL_ID } from '@vizsla/constants';
import { useModal } from '..';
export const useSwitchUserRoleModal = () => {
    const { isOpen: isSwitchUserRoleModalOpen, openModal: openSwitchUserRoleModal, closeModal: closeSwitchUserRoleModal, } = useModal(SWITCH_USER_ROLE_MODAL_ID);
    return { isSwitchUserRoleModalOpen, openSwitchUserRoleModal, closeSwitchUserRoleModal };
};
